import { render, staticRenderFns } from "./offshoreLeaks.vue?vue&type=template&id=0f2ddf3e&scoped=true&"
import script from "./offshoreLeaks.vue?vue&type=script&lang=js&"
export * from "./offshoreLeaks.vue?vue&type=script&lang=js&"
import style0 from "./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss?vue&type=style&index=0&id=0f2ddf3e&prod&scoped=true&lang=scss&"
import style1 from "./offshoreLeaks.vue?vue&type=style&index=1&id=0f2ddf3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ddf3e",
  null
  
)

export default component.exports